import { render, staticRenderFns } from "./VploadImgFour.vue?vue&type=template&id=0e63e208"
import script from "./VploadImgFour.vue?vue&type=script&lang=js"
export * from "./VploadImgFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports